import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <div className="container">
        <h2 className="section-title">What Designers Say</h2>
        <div className="testimonial-content">
          <div className="testimonial-video">
            <div className="video-placeholder">
              <img
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1200&h=600&fit=crop"
                alt="Design workspace with framed artwork on the wall"
                className="testimonial-image"
              />
              <button className="play-button" aria-label="Play testimonial video">
                ▶
              </button>
            </div>
          </div>
          <div className="testimonial-quote">
            <p className="quote-text">
              “This platform completely transformed how I source materials and connect with
              clients. Everything I need is finally in one place.”
            </p>
            <div className="quote-author">
              <img
                src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=120&h=120&fit=crop"
                alt="Sarah Jenkins"
                className="author-avatar"
              />
              <div className="quote-author-text">
                <p className="author-name">Sarah Jenkins</p>
                <p className="author-title">Interior Designer</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

